import groupBuying from './modules/group-buying/index.js';
import login from './modules/login/index';
import wxPay from './modules/wxPay';
import course from './modules/course';
import vip from './modules/vip';
import registration from './modules/registration-info/index.js';
import my from './modules/my'
import home from './modules/home'
import search from './modules/search'
import note from './modules/note'
export default {
  groupBuying,
  login,
  wxPay,
  course,
  vip,
  registration,
  my,
  home,
  search,
  note,
}
